import { createSelector } from 'reselect';

export const getUser = (state) => state.user || {};
export const getUserToken = () => createSelector(getUser, (user) => user.token);
export const getLicenseModal = () =>
  createSelector(getUser, (user) => user.licenseModal);
